import React from 'react';
import './PrivacyModel.css';

const FaqModal = ({ show, onClose }) => {
  if (!show) return null;

  const faqs = [
    {
      question: "What is Resumeglobe?",
      answer: "Resumeglobe is a software tool that helps you create professional resumes and cover letters with AI assistance."
    },
    {
      question: "Why choose Resumeglobe?",
      answer: "At Resumeglobe, we care about our customers. You can build your resume for FREE, and enjoy exciting additional features as a subscribed user."
    },
    {
      question: "How can I contact the customer support team?",
      answer: 'You can reach our customer support team at <a href="mailto:support@resumeglobe.com" style="color:#1e5128;font-weight:600;text-decoration:none;">support@resumeglobe.com</a> for any queries or assistance.'
    },
    {
      question: "How can I check my ATS score?",
      answer: "To check your ATS score, simply upload your resume and our AI will instantly analyse it to show where you stand out and what can be improved."
    },
    {
      question: "Does Resumeglobe offer refunds?",
      answer: "Our refund policies have certain limitations. Kindly refer to our Refund Policy page for more details."
    },
    {
      question: "How long does it take to process refund requests?",
      answer: "Refunds are processed based on the request. If approved, your refund will be completed within 2–7 working days, depending on your bank."
    },
    {
      question: "How can I reset my password?",
      answer: "Click on \"Forgot Password\" to reset your password, or contact our customer support team for assistance."
    },
    {
      question: "What are the pricing plans?",
      answer: "We offer premium features at an affordable price. To view our pricing, please visit the Pricing page."
    },
    {
      question: "How can I delete or deactivate my account?",
      answer: "To delete or deactivate your account, please sign in to your account and create a support ticket. If you're unable to access your account, you can also contact our customer support team by email."
    },
    {
      question: "Can I edit my resume after downloading?",
      answer: "Yes! You can edit your resume by clicking the \"Edit\" button in the \"My Files\" section."
    },
    {
      question: "Can I update my resume?",
      answer: "Yes, you can upload your existing resume using the \"Upload Resume\" button."
    },
    {
      question: "Do I need an account to create a resume?",
      answer: "No, you can start creating your resume right away! However, before downloading, please log in or sign up to your profile."
    },
    {
      question: "Is my data safe?",
      answer: "Yes, your data is protected. We also do not store any data from users who upload their resumes."
    },
    {
      question: "Can I use Resumeglobe on mobile or tablet?",
      answer: "Yes! Resumeglobe is designed for a wide range of users and works seamlessly across all devices — including mobile phones, tablets, and laptops."
    },
    {
      question: "What are the premium features of Resumeglobe?",
      answer: "Resumeglobe allows users to check their resume score for FREE! With our AI-powered tools, you can update and enhance your resume with detailed feedback on your ATS score, highlight your strengths, develop your skills using our AI Career Map and Tool Kit. Login/Signup to explore more."
    }
  ];

  return (
    <div className="privacy-model-overlay" onClick={onClose}>
      <div className="privacy-model-content" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-model-header">
          <h2>Frequently Asked Questions</h2>
          <button className="privacy-model-close" onClick={onClose}>×</button>
        </div>
        
        <div className="privacy-model-body">
          <div className="privacy-section">
            <p style={{ fontSize: '1.1rem', color: '#64748b', marginBottom: '30px' }}>Everything you need to know about ResumeGlobe</p>
          </div>

          {faqs.map((faq, index) => (
            <div key={index} className="privacy-section">
              <h3>{index + 1}. {faq.question}</h3>
              <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </div>
          ))}

          <div className="privacy-section" style={{ marginTop: '40px', padding: '24px', background: '#f0f9f4', borderLeft: '4px solid #1e5128', borderRadius: '8px' }}>
            <h3 style={{ marginTop: 0 }}>Still have questions?</h3>
            <p style={{ marginBottom: 0 }}>Contact us at <a href="mailto:support@resumeglobe.com" style={{ color: '#1e5128', fontWeight: '600', textDecoration: 'none' }}>support@resumeglobe.com</a></p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-close-modal" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default FaqModal;
